const PREFIX = '#thread-';

export function getThreadIdFromUrlHash(hash: string) {
  return typeof hash === 'string' && hash.startsWith(PREFIX)
    ? hash.slice(PREFIX.length)
    : null;
}

export default function commentThreadHash(threadId: string) {
  return `${PREFIX}${threadId}`;
}
